import { makeStyles } from "@mui/styles";
import { BaseThemeOptions } from "themes/base";

export const useStyles = makeStyles((theme: BaseThemeOptions) => ({
	editIconBox: {
		cursor: "pointer",
		marginBottom: "4px",
		"&:hover": {
			"& path": {
				stroke: theme.palette.primary.main,
			},
		},
	},
}));
